import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import FeedPostSlider from 'src/app/molecules/FeedPostSlider/FeedPostSlider';
import { IStaticContentfulImages } from 'src/types/contentful';

const imageMaxWidth = 336;

const CommunityDesignFeed = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      image0: contentfulAsset(contentful_id: { eq: "LQKC1e8ARJC75eDljvRIx" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image1: contentfulAsset(contentful_id: { eq: "AKPAVdqUTSZ3UdahYYizs" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image2: contentfulAsset(contentful_id: { eq: "2t883jA8n6hEerP8AZJQl1" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
      image3: contentfulAsset(contentful_id: { eq: "6XUvMdF3XxCTqg8BO6pKSD" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 800)
      }
    }
  `);

  const posts = [
    {
      image: {
        image: images.image0.gatsbyImageData,
        alt: 'Community Design',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image1.gatsbyImageData,
        alt: 'Community Design',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image2.gatsbyImageData,
        alt: 'Community Design',
      },
      imageMaxWidth,
    },
    {
      image: {
        image: images.image3.gatsbyImageData,
        alt: 'Community Design',
      },
      imageMaxWidth,
    },
  ];

  return <FeedPostSlider posts={posts} />;
};

export default CommunityDesignFeed;
